import block from 'module-clsx';
import styles from '../scss/title.module.scss';

const clsx = block(styles);

function Title() {
    return (
        <div className={clsx('wrapper')}>
            <div className={clsx('overlay')}></div>
            <svg
                className={clsx('title')}
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="700.000000pt"
                height="178.000000pt"
                viewBox="0 0 700.000000 178.000000"
                preserveAspectRatio="xMidYMid meet"
            >
                <g
                    transform="translate(0.000000,178.000000) scale(0.100000,-0.100000)"
                    // fill="#000000"
                    // stroke="none"
                >
                    <path
                        d="M1846 1758 c-9 -12 -16 -30 -16 -39 0 -19 -60 -181 -85 -228 -13 -27
                    -21 -31 -56 -31 -127 0 -426 -74 -437 -107 -7 -24 29 -26 72 -5 109 55 285 93
                    379 83 13 -2 -39 -94 -122 -218 -149 -221 -309 -382 -447 -449 -129 -62 -220
                    -39 -212 52 3 36 5 39 40 45 87 14 109 99 26 99 -20 0 -50 -21 -116 -81 -205
                    -187 -493 -361 -655 -396 -76 -16 -78 -16 -105 4 -47 34 -53 58 -48 168 5 110
                    33 234 56 245 8 4 54 26 102 49 114 54 231 142 348 261 213 216 309 406 256
                    508 -37 71 -148 63 -273 -21 -85 -56 -138 -115 -232 -252 -180 -263 -299 -566
                    -308 -785 -5 -118 10 -154 77 -188 37 -19 54 -22 95 -17 162 20 345 122 661
                    368 24 19 24 18 24 -7 0 -76 41 -108 137 -108 55 0 78 6 137 36 118 58 265
                    194 387 359 67 89 165 246 186 294 7 18 18 33 24 33 7 0 8 -7 4 -17 -36 -86
                    -207 -672 -264 -902 -66 -266 -102 -484 -83 -503 20 -20 32 4 32 66 0 175 118
                    636 304 1185 31 91 56 166 56 168 0 2 24 3 53 1 47 -3 52 -5 49 -25 -4 -31 16
                    -29 28 1 10 28 -3 28 200 -4 63 -10 116 -17 118 -15 16 16 -112 44 -263 57
                    -22 2 -31 9 -35 27 -8 35 -28 37 -40 6 -9 -25 -14 -27 -48 -20 -20 4 -39 9
                    -41 11 -2 2 17 63 43 135 26 71 46 140 44 152 -4 30 -33 33 -52 5z m-1051 -43
                    c76 -75 -19 -262 -249 -491 -88 -88 -161 -151 -221 -190 -97 -63 -191 -111
                    -201 -102 -3 3 16 57 41 119 126 310 323 586 468 659 76 38 128 40 162 5z
                    m221 -787 c10 -15 -32 -48 -62 -48 -31 0 -30 14 2 39 30 24 49 27 60 9z"
                    ></path>
                    <path
                        d="M4004 1713 c-95 -214 -260 -486 -408 -669 -190 -236 -414 -378 -479
                    -306 -22 24 -21 77 2 129 22 47 52 67 88 58 20 -5 24 -2 21 12 -5 29 -54 28
                    -99 -1 -45 -30 -67 -68 -75 -129 -17 -119 138 -144 283 -46 110 75 283 263
                    397 431 33 49 61 86 63 84 3 -2 -3 -28 -12 -58 -35 -118 -83 -445 -74 -508 3
                    -20 11 -26 35 -28 29 -3 39 6 119 97 135 157 175 167 172 39 -2 -65 0 -71 26
                    -94 20 -17 40 -24 69 -24 53 0 198 49 317 108 53 26 99 48 104 50 4 2 7 -14 7
                    -37 0 -76 31 -111 112 -126 80 -15 283 39 489 131 56 25 104 43 106 40 3 -3 0
                    -20 -6 -38 -5 -18 -15 -72 -22 -121 -14 -114 -2 -174 47 -216 47 -42 87 -47
                    186 -22 148 38 308 128 524 297 53 42 98 73 101 71 2 -3 0 -31 -6 -63 -16 -85
                    -14 -209 4 -244 38 -73 102 -90 220 -60 151 38 343 151 571 336 104 84 124
                    104 103 104 -8 0 -57 -37 -109 -81 -121 -102 -303 -225 -411 -278 -106 -52
                    -242 -87 -281 -72 -67 26 -83 126 -48 294 12 59 28 111 34 116 6 5 57 32 112
                    60 122 61 198 116 311 224 171 164 298 352 310 459 10 87 -49 146 -133 133
                    -161 -24 -361 -230 -517 -533 -45 -86 -119 -263 -130 -313 -12 -49 -326 -282
                    -489 -363 -103 -51 -238 -90 -280 -80 -38 8 -66 46 -74 102 -8 57 8 187 33
                    262 l18 54 110 56 c61 30 149 85 195 121 216 169 409 422 427 558 7 51 -18
                    106 -58 126 -41 22 -95 14 -179 -26 -161 -76 -371 -365 -495 -679 -20 -52 -42
                    -108 -49 -123 -9 -24 -31 -37 -116 -74 -236 -100 -436 -155 -492 -134 -58 22
                    -74 91 -38 170 11 23 17 47 14 52 -11 18 -41 8 -63 -22 -39 -53 -352 -188
                    -444 -192 l-52 -2 -5 83 c-4 74 -8 86 -30 104 -18 15 -33 18 -59 14 -40 -6
                    -68 -31 -163 -143 -38 -46 -73 -83 -78 -83 -16 0 -11 110 9 226 33 181 68 285
                    186 554 110 249 116 265 102 279 -19 19 -27 12 -53 -46z m2015 8 c80 -80 -35
                    -302 -276 -532 -111 -106 -293 -230 -370 -254 -33 -9 -30 6 22 131 128 306
                    325 579 465 647 67 32 132 35 159 8z m826 13 c20 -8 45 -56 45 -88 0 -116
                    -227 -412 -436 -569 -82 -62 -229 -147 -254 -147 -18 0 -7 37 52 170 132 299
                    312 545 447 613 52 26 111 34 146 21z"
                    ></path>
                    <path
                        d="M4650 1080 c-6 -12 -10 -33 -8 -48 4 -35 34 -36 60 -1 16 22 18 30 9
                    48 -15 27 -47 27 -61 1z"
                    ></path>
                    <path
                        d="M1973 928 c-66 -71 -77 -129 -46 -270 17 -80 16 -88 -25 -180 -2 -5
                    3 -8 10 -8 8 0 22 16 31 35 28 60 126 118 402 240 177 78 305 143 305 155 0
                    14 3 15 -132 -49 -68 -33 -186 -88 -263 -122 -77 -35 -169 -80 -204 -101 -34
                    -21 -67 -38 -72 -38 -5 0 -9 20 -9 44 0 24 -5 68 -10 97 -15 76 -4 124 37 170
                    19 21 32 43 28 49 -10 16 -19 12 -52 -22z"
                    ></path>
                </g>
            </svg>
        </div>
    );
}

export default Title;
